import React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import { IRequestArtifactTabs } from '../request-artifacts-popover';
import { TRequestArtifactsTab } from '../../../../../../api/artifacts.dao';

export interface IRequestArtifactsPopoverHeaderProps {
    currentTabs: IRequestArtifactTabs[];
    selectedTab: TRequestArtifactsTab;
    setSelectedTab: (type: TRequestArtifactsTab) => void;
}

export const RequestArtifactsPopoverHeader = observer(({
    currentTabs,
    selectedTab,
    setSelectedTab,
}: IRequestArtifactsPopoverHeaderProps) => {

    return (
        <div className='request-artifacts-popover__header'>
            <div className='request-artifacts-popover__tabs'>
                {currentTabs
                    .map(tab =>
                        (<div
                            key={tab.type}
                            className={classNames('request-artifacts-popover__tab', {
                                'request-artifacts-popover__tab--selected': tab.type === selectedTab
                            })}
                            onClick={() => setSelectedTab(tab.type)}
                            onKeyDown={() => setSelectedTab(tab.type)}
                        >
                            { tab.label }
                        </div>)
                    )
                }
            </div>
        </div>
    );
});
